import * as React from "react";
import type { SVGProps } from "react";
const SvgBox = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21.532 7.2H2.468M15 10.5H9m12.6-2.733V19.2a2.4 2.4 0 0 1-2.4 2.4H4.8a2.4 2.4 0 0 1-2.4-2.4V7.767c0-.373.087-.74.253-1.074l1.65-3.298a1.8 1.8 0 0 1 1.61-.995h12.175a1.8 1.8 0 0 1 1.61.995l1.649 3.298c.166.334.253.701.253 1.074"
    />
  </svg>
);
export default SvgBox;
